<div
    role="combobox"
    [attr.aria-controls]="isMenuVisible ? id+'-panel' : null"
    aria-haspopup="listbox"
    [attr.aria-labelledby]="dropdownLabel"
    [attr.aria-expanded]="isMenuOverlayTriggered && isMenuVisible"
    [attr.aria-activedescendant]="isMenuVisible && activeIndex !== null ? id + '-option-'+activeIndex : null"
    (keydown)="onKeyDown($event)"
    (click)="onDropdownClick($event)"
    (blur)="onBlurEvent.emit()"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    [id]="id"
    tabindex="0"
    #dropdownTrigger
    [ngClass]="['valg-input', 'valg-input__dropdown', displayValue ? '' : 'placeholder', isDisabled ? 'disabled': '', fullWidth ? 'full-width': '', doubleWidth ? 'double-width': '']"
    [attr.aria-disabled]="isDisabled ? 'true' : null">
    {{displayValue ? displayValue : (placeholder ?? "" | translate)}}
    <mat-icon [svgIcon]="SvgIcon.DropdownArrow" [ngClass]="[isMenuOverlayTriggered && isMenuVisible ? 'rotated': '']"></mat-icon>
</div>

<ng-template
  #optionsContainer="cdkConnectedOverlay"
  cdkConnectedOverlayPanelClass="valg-input-dropdown-overlay"
  [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
  [cdkConnectedOverlayPositions]="overlayConnectedPositions"
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isMenuOverlayTriggered">
  <div role="listbox" [ngClass]="['menu', isMenuVisible ? 'visible' : '', doubleWidth ? 'double-width': '']" #dropdownMenu [attr.aria-labelledby]="dropdownLabel" [id]="id+'-panel'" [attr.style]="maxHeight ? '--dropdown-max-height:'+maxHeight+'px' : null">
    <div class="menu__content">
      <valg-input-dropdown-option
        *ngFor="let option of getActiveOptions()" (click)="onItemClicked($event, option)"
        [id]="getDropdownItemComponentId(option)"
        [ngClass]="['menu__content__item', displayValue === option.label ? 'menu__content__item__selected': '', option.disabled ? 'menu__content__item__disabled' : '']"
        [selected]="selectedItemComponentId === getDropdownItemComponentId(option)"
        (selectionChange)="onSelectionChange(option)"
      >
        {{option.label}}
      </valg-input-dropdown-option>
    </div>
  </div>
</ng-template>
